import transport from './transport'

const API = {
	transport
};

export default API;
